import "./ArticleCard.scss";

import PropTypes from "prop-types";

import * as React from "react";
import * as _ from "lodash";
import { FormattedMessage } from "react-intl";
import { Button, OverlayTrigger, Popover } from "react-bootstrap";
import { Link } from "react-router";
import { generateUuid } from "shared/src/utils/util";
import { canNotBeAddedToBasket } from "../../../../../../utils/BasketUtil";
import {
    trackArticleView,
    trackOpenProductView,
    trackShopLinkClick
} from "../../../../../../utils/ArticleTrackingUtil";
import { trackAddItemToList, trackAddItemToListGA, trackReplacement } from "shared/src/tracking/ListTrackingUtil";
import {
    getDefaultImageHeight,
    getDefaultImageWidth,
    getImageBreakPointConfigs
} from "../../../../../../utils/ArticleCardUtil";
import { getRewardIds } from "shared/src/utils/rewardArticleIds";

import { SessionStore } from "shared/src/uidispatcherapi/SessionStore";
import * as articleUtils from "../../../../../../utils/articleUtils";
import { normalizeAmount } from "../../../../../../utils/mathUtil";
import * as ListPageUtils from "shared/src/utils/ListPageUtils";
import { ArticleSelectionListProps } from "shared/src/utils/ListPageUtils";
import ShoppingListActions from "shared/src/actions/ShoppingListActions";
import ListAction from "shared/src/actions/ListAction";
import FetchArticlesAction from "shared/src/actions/FetchArticlesAction";
import CustomerHistoryAction from "../../../../../../actions/CustomerHistoryAction";
import { AddToBasketControl } from "../../../AddToBasketControl";
import { AddToListDropdown } from "../../../../lists/dropdowns/AddToListDropdown";
import BundleSelector from "../BundleSelector";
import BundleImage from "../BundleImage";
import { StockPanel } from "../StockPanel";
import TitlePanel from "../TitlePanel";
import DisplayReplacementPopover from "../DisplayReplacementPopover";
import BundlePrice from "../BundlePrice";
import { PromotionLabels } from "../../../PromotionLabels";

import ReplaceListItemSubstitutes from "../ReplaceListItemsSubstitutes";

import { SearchResultDebugInfoPanel } from "../../debug/SearchResultDebugInfo";
import { saveRecentSearches } from "../../../RecentSearches";
import { ListDeleteFunction, ListDeleteTracking } from "shared/src/types/ListItemRenderData";
import { SearchResultLayout } from "../../SearchResultLayout";
import { ReplaceInfo } from "../ReplaceListItem";
import {
    ArticleIdsRenderData,
    AvailabilityRenderData,
    BuyabilityRenderData,
    ImageUrls,
    ListInformation,
    Location
} from "shared/src/types/articlesearch/Article";
import { PriceAndPromotionInfo } from "shared/src/types/PriceAndPromotionInfo";

import { SearchResultDebugInfo, SearchResultLtrDebugInfo } from "shared/src/types/articlesearch/SearchResult";
import { TrackingTags } from "shared/src/tracking/Tracking";
import { PageType } from "shared/src/types/PageType";
import { ZeroResultType } from "shared/src/types/ZeroResultType";
import { ShoppingCartPosition } from "shared/src/types/ShoppingCartPosition";
import { WeightPerPieceUnit } from "shared/src/types/articlesearch/Article";
import {
    alwaysShowAlternatives,
    showEVAlternativesComponentDebugToggle
} from "../../../../../../searchdiscover/toggles";
import DeleteFromListButton from "../DeleteFromListButton";
import IconWithLabel from "../../../../../orderhistory/details/suborder/IconWithLabel";
import { isTier12Customer } from "shared/src/stores/SessionStore";
import { getComponentByName } from "shared/src/components/LazyWrapper";
import { isTouchScreen } from "shared/src/utils/isTouchScreen";
import { calculateAmountToDisplay } from "shared/src/utils/BasketUtil";
const AlternativesButtonWithModal = getComponentByName("sd_pdp_ui/AlternativesButtonWithModal");

type ArticleCardProps = {
    buyability: BuyabilityRenderData;
    availabilityInfo: AvailabilityRenderData;
    priceAndPromotionInfo: PriceAndPromotionInfo;
    articleIds: ArticleIdsRenderData;
    pvLink: Location;
    marketplace: boolean;
    marketPlaceShopInfo: {
        shopId: string | undefined | null;
        shopName: string;
    };
    description: string;
    imageUrls: ImageUrls;
    storeName: string | undefined | null;
    isWeightArticle: boolean;
    weightPerPiece: WeightPerPieceUnit | undefined | null;
    netPieceWeight: number | undefined | null;
    numberOfBundles: number;
    bundleSelector: {
        [x: string]: string;
    };
    trackingInfo: TrackingTags;
    listInformation: ListInformation;
    readOnly: boolean;
    debugInfo: SearchResultDebugInfo | undefined | null;
    ltrDebugInfo: SearchResultLtrDebugInfo | undefined | null;
    replace: ReplaceInfo | undefined | null;
    inContainer: boolean | undefined | null;
    cartEnabled: boolean;
    amountInBasket: number | null;
    // TODO(FD) this should be named shoppingCartItem or shoppingCartPosition
    priceInBasket: ShoppingCartPosition | undefined | null;
    addButton: any;
    BSonSelect: (x0: string) => false;
    listOfArticles: any;
    recentlyOrdered: boolean;
    recentlyOrderedDateString?: string;
    onList: boolean;
    showOtherBundle: boolean;
    searchResultLayout: SearchResultLayout;
    deprecated: boolean;
    renderedDeprecatedArticle?: React.ReactNode;
    deleteAction: ListDeleteFunction | undefined | null;
    deleteTracking: ListDeleteTracking | undefined | null;
    pageType: PageType;
    zeroResultType: ZeroResultType | undefined | null;
    nonExistentBundle: boolean;
    tabIndex?: number;
    listPosition?: number;
    minOrderQuantity?: number;
    articleSelectionListProps: ArticleSelectionListProps | undefined | null;
    recentlyAddedExpiration: Date | undefined | null;
    onShowBundles: (() => void) | undefined;
    onHideBundles: (() => void) | undefined;
    solrScore: number | null | undefined;
    showEVAlternativesButtonWithModal?: boolean | null | undefined;
};

type State = { addButtonIsFocused: boolean };

class ArticleCard extends React.Component<ArticleCardProps, State> {
    static contextTypes = {
        intl: PropTypes.object.isRequired
    };
    eventId: string;
    rewardIds: string[] | null;

    constructor(props: ArticleCardProps) {
        super(props);
        this.eventId = generateUuid();
        this.rewardIds = getRewardIds(this.props.priceAndPromotionInfo, this.props.articleIds.selectedBundleId);
        this.state = { addButtonIsFocused: false };
    }

    /*
     *  This ensures that when bundle is switched, new eventId is generated.
     */
    componentWillReceiveProps(nextProps: ArticleCardProps) {
        if (this.props.articleIds.selectedBundleId !== nextProps.articleIds.selectedBundleId) {
            this.eventId = generateUuid();
        }
    }

    shouldShowAlternativesLink() {
        return (
            alwaysShowAlternatives() ||
            this.props.availabilityInfo.availability === "UNAVAILABLE" ||
            this.props.availabilityInfo.delisted
        );
    }

    useNewAlternativesButton() {
        return ListPageUtils.isAListPage(this.props.pageType);
    }

    shouldShowAlternativesButtonPlusInNewDesign() {
        return this.shouldShowAlternativesLink() && this.useNewAlternativesButton();
    }

    getNormalizedAmount() {
        return normalizeAmount(this.props.listInformation.listAmount);
    }

    getAmountValueParsed() {
        if (this.refs.amountInput) {
            if (this.props.isWeightArticle) {
                return parseFloat((this.refs.amountInput as any).value.replace(",", ".")) || 0.0;
            }
            return parseInt((this.refs.amountInput as any).value, 10) || 1;
        }
        return 1;
    }

    handleReplaceArticle = () => {
        const replace = this.props.replace;
        const ids = this.props.articleIds.forListActions;
        if (!replace) {
            return;
        }
        const value = normalizeAmount(this.getAmountValueParsed());
        const replaceData = _.assign({}, replace, {
            newBundleId: ids.newBundleId,
            bettyVariantId: ids.bettyVariantId,
            newAmount: value
        });
        ShoppingListActions.replaceItem(replaceData as any);
        FetchArticlesAction([ids.bettyVariantId]);
        const oldBundleId = replace.oldBundleId || replace.bettyBundleId;
        const newBundleId: string | undefined | null = _.get(ids, ["newBundleId", "bettyBundleId"]);
        if (newBundleId && oldBundleId) {
            trackReplacement(newBundleId, oldBundleId, this.props.trackingInfo.replacementKind || "NONE");
        }
        replace.close();
    };

    // create new list handler
    createNewList = (name: string, globallyVisible: boolean, readOnlyForEmployees: boolean) => {
        const newListItemData = {
            articleVariantId: this.props.articleIds.forListActions.bettyVariantId,
            bettyBundleId: this.props.articleIds.selectedBundleId
        };
        ListAction.create(name, globallyVisible, [newListItemData], readOnlyForEmployees);
        trackAddItemToList(
            this.eventId,
            this.props.articleIds.selectedBundleId,
            this.props.articleIds.trackingId,
            this.props.pageType,
            this.props.zeroResultType,
            this.props.inContainer || false,
            this.props.listInformation.listType || "unknown",
            this.props.listInformation.listId || "",
            this.props.listInformation.listName || "unknown",
            this.props.marketplace,
            this.props.articleIds.offerId,
            this.props.trackingInfo?.ownBrand,
            this.props.trackingInfo?.ropoRank
        );
        trackAddItemToListGA(this.props.articleIds.selectedBundleId);
    };

    handleLinkClick(origin: string) {
        trackOpenProductView(
            this.eventId,
            this.props.articleIds.selectedBundleId,
            this.props.articleIds.trackingId,
            this.props.pageType,
            this.props.zeroResultType,
            this.props.inContainer,
            origin,
            this.props.marketplace,
            this.props.articleIds.offerId,
            this.props.trackingInfo
        );
        CustomerHistoryAction.loadArticles.trigger();
    }

    handleMerchantLinkClick = () => {
        trackShopLinkClick(
            this.eventId,
            this.props.articleIds.selectedBundleId,
            this.props.articleIds.trackingId,
            this.props.marketPlaceShopInfo.shopId || "",
            this.props.pageType,
            this.props.zeroResultType,
            this.props.inContainer
        );
    };

    track(imageType: string): void {
        const replacementLinkShown =
            !this.props.readOnly &&
            ListPageUtils.showReplacementLink(this.props.availabilityInfo, this.props.listInformation);

        trackArticleView(
            this.eventId,
            this.props.articleIds.selectedBundleId,
            this.props.articleIds.trackingId,
            this.props.description,
            imageType,
            this.props.pageType,
            this.props.zeroResultType,
            this.props.inContainer,
            this.props.onList,
            this.props.recentlyOrdered,
            this.props.availabilityInfo.availability,
            this.props.marketplace,
            this.props.articleIds.offerId,
            this.props.trackingInfo,
            replacementLinkShown,
            this.props.solrScore,
            this.props.articleIds.childBundleIds,
            this.rewardIds,
            this.props.searchResultLayout
        );
    }

    renderArticleImage() {
        return (
            <div className="mfcss_card-article-2--image" role="region" aria-label="Article">
                <Link
                    className="image"
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore -- FIXME check whether this does anything
                    description={this.props.description}
                    to={this.props.pvLink}
                    onClick={() => {
                        this.handleLinkClick("image");
                        saveRecentSearches();
                    }}>
                    <BundleImage
                        onSuccessfulLoad={(imageType) => this.track(imageType)}
                        src={this.props.imageUrls}
                        description={this.props.description}
                        breakPointConfigs={getImageBreakPointConfigs(this.props.searchResultLayout)}
                        defaultWidth={getDefaultImageWidth(this.props.searchResultLayout)}
                        defaultHeight={getDefaultImageHeight(this.props.searchResultLayout)}
                    />
                </Link>
            </div>
        );
    }

    renderDeleteButton(showDeleteButton: boolean) {
        const ids = this.props.articleIds.forListActions;
        const itemData = {
            variantId: ids.bettyVariantId,
            originalBundleId: ids.originalBundleId,
            bettyBundleId: ids.idForList
        };
        const listInformation = this.props.listInformation;
        const deleteData = {
            listId: listInformation.listId,
            listType: listInformation.listType,
            listName: listInformation.listName,
            deleteAction: this.props.deleteAction,
            deleteTracking: this.props.deleteTracking
        };
        return <DeleteFromListButton itemData={itemData} showDeleteButton={showDeleteButton} deleteData={deleteData} />;
    }

    renderAddToListButton() {
        if (!SessionStore.loggedIn() || isTier12Customer()) {
            // don't show add to list button for anons.
            //  - why not also in other cases where it's disabled? I think it
            //    makes sense to show that the button exists, but currently
            //    can't be used in those cases.
            return null;
        }
        const isReplacementSearch = !_.isNil(this.props.replace);
        return (
            <AddToListDropdown
                eventId={this.eventId}
                trackingId={this.props.articleIds.trackingId}
                createNewList={this.createNewList}
                bettyBundleId={this.props.articleIds.forListActions.idForList}
                bettyVariantId={this.props.articleIds.forListActions.bettyVariantId}
                pageType={this.props.pageType || undefined}
                zeroResultType={this.props.zeroResultType}
                inContainer={this.props.inContainer || undefined}
                disabled={!SessionStore.loggedIn() || isReplacementSearch || this.props.nonExistentBundle}
                articleDeprecated={this.props.deprecated}
                marketplace={this.props.marketplace}
                offerId={this.props.articleIds.offerId}
                ownBrand={this.props.trackingInfo?.ownBrand}
                ropoRank={this.props.trackingInfo?.ropoRank}
            />
        );
    }

    renderToggleBundlesButton(numberOfAdditionalBundles: number) {
        if (this.props.onShowBundles) {
            const messageId = numberOfAdditionalBundles === 1 ? "EX_SHOW_ONE_MORE_BUNDLE" : "EX_SHOW_MORE_BUNDLES";
            return (
                <Button bsStyle="link" onClick={this.props.onShowBundles} className="btn btn-block btn-toggle-bundles">
                    <FormattedMessage id={messageId} values={{ number: numberOfAdditionalBundles }} />
                </Button>
            );
        } else if (this.props.onHideBundles) {
            return (
                <Button bsStyle="link" onClick={this.props.onHideBundles} className="btn btn-block btn-toggle-bundles">
                    <FormattedMessage id="EX_HIDE_BUNDLES" />
                </Button>
            );
        } else {
            return null;
        }
    }

    renderBundleSelector() {
        const numberOfAdditionalBundles = this.props.nonExistentBundle
            ? this.props.numberOfBundles
            : this.props.numberOfBundles - 1;
        if (numberOfAdditionalBundles > 0) {
            const showOldBundleSelector =
                this.props.listInformation.listType && this.props.listInformation.listType !== ListPageUtils.storeList;
            if (!showOldBundleSelector) {
                return (
                    <div className="mfcss_card-article-2--bundleinfo-2" role="region" aria-label="Article card">
                        {this.renderToggleBundlesButton(numberOfAdditionalBundles)}
                    </div>
                );
            } else {
                // list page bundle selector
                return (
                    <div className="mfcss_card-article-2--bundleinfo-2" role="region" aria-label="Article card">
                        <BundleSelector
                            id={this.props.articleIds.selectedBundleId}
                            emptyText={<FormattedMessage id="EX_SELECTOR_NONE_SELECTED" />}
                            items={this.props.bundleSelector}
                            selection={this.props.nonExistentBundle ? null : this.props.articleIds.selectedBundleId}
                            weightPerPiece={this.props.weightPerPiece}
                            listOfArticles={this.props.listOfArticles}
                            onSelect={this.props.BSonSelect}
                            disabled={this.props.deprecated || this.props.isWeightArticle}
                            showOtherBundle={this.props.showOtherBundle}
                            numberOfAdditionalBundles={numberOfAdditionalBundles}
                        />
                    </div>
                );
            }
        } else {
            return null;
        }
    }

    renderActions(showDeleteButton: boolean) {
        const actionButton = this.shouldShowAlternativesButtonPlusInNewDesign()
            ? this.renderReplacementSearchLink()
            : this.renderActionButton();
        return (
            <div className="mfcss_card-article-2--buttons test-actions" role="region" aria-label="Article actions">
                <div
                    className="mfcss_card-article-2--buttons-row no-top-margin"
                    role="region"
                    aria-label="Article actions">
                    {actionButton}
                </div>
                {this.props.nonExistentBundle && (
                    <div className="mfcss_card-article-2--buttons-row" role="region" aria-label="Article actions">
                        {this.renderDeleteButton(showDeleteButton)}
                        {this.renderAddToListButton()}
                    </div>
                )}
            </div>
        );
    }

    renderSecondaryActions(showDeleteButton: boolean) {
        return (
            <div className="mfcss_card-article-2--secondary-actions" role="region" aria-label="Article actions">
                {this.renderAddToListButton()}
                {this.renderDeleteButton(showDeleteButton)}
            </div>
        );
    }

    renderPrice(price: React.ReactNode) {
        return (
            <div className="mfcss_card-article-2--price-unit test-price" role="region" aria-label="Article price">
                {price}
            </div>
        );
    }

    renderReplacementSearchLink() {
        if (this.props.readOnly) {
            return null;
        }
        const shouldShow = this.shouldShowAlternativesLink();
        if (!shouldShow) {
            return null;
        }
        const onList = this.props.listInformation.listId;
        if (onList) {
            const ids = this.props.articleIds.forListActions;
            const content = this.useNewAlternativesButton() ? (
                <Button block>
                    <IconWithLabel size="lg" symbol="replacement" labelId={"CA_REPLACE_ARTICLE_ON_LIST"} />
                </Button>
            ) : (
                <FormattedMessage id="EX_FIND_REPLACE" />
            );
            return (
                <ReplaceListItemSubstitutes.Trigger
                    asButton={this.useNewAlternativesButton()}
                    listId={this.props.listInformation.listId}
                    listOfArticles={this.props.listOfArticles}
                    bettyVariantId={ids.bettyVariantId}
                    bundleId={ids.originalBundleId}
                    artName={this.props.description}
                    pageType={this.props.pageType}>
                    {content}
                </ReplaceListItemSubstitutes.Trigger>
            );
        } else {
            return null;
        }
    }

    getEVAlternativesButtonWithModalIfApplicable() {
        if (!this.props.showEVAlternativesButtonWithModal && !showEVAlternativesComponentDebugToggle()) {
            return null;
        }
        return (
            <AlternativesButtonWithModal
                mainBundleCustomerBuyable={this.props.buyability.customer}
                articleName={this.props.description || ""}
                isLoggedIn={SessionStore.loggedIn()}
                isEmployee={SessionStore.isEmployee()}
                storeName={this.props.storeName}
                changedStoreData={null}
                isCustomer={SessionStore.isCustomer()}
                originalArticle={{
                    selectedDeliveryMode: this.props.buyability.deliveryMode,
                    price: this.props.priceAndPromotionInfo,
                    availability: this.props.availabilityInfo.availability,
                    description: this.props.description,
                    mgbNo: this.props.trackingInfo.mgbNumber,
                    bettyBundleId: this.props.articleIds.selectedBundleId,
                    imageUrl: this.props.imageUrls.variant,
                    customerDisplayId: this.props.articleIds.idForDisplay
                }}
                pageType={this.props.pageType}
                closeAutomatically={false}
                excludedBundleIds={[]}
            />
        );
    }

    renderAvailability() {
        const availabilityInfo = this.props.availabilityInfo;
        const replacementSearchLink = this.useNewAlternativesButton() ? null : this.renderReplacementSearchLink();
        return (
            <div className="mfcss_card-article-2--availability" role="region" aria-label="Article availability">
                <StockPanel
                    availability={availabilityInfo.availability}
                    showAvailability={availabilityInfo.showAvailability}
                    delisted={availabilityInfo.delisted}
                    deliveryDate={availabilityInfo.deliveryDate}
                    deliveryMode={availabilityInfo.deliveryMode}
                    storeName={this.props.storeName}
                    replacementSearchLink={replacementSearchLink}
                />
            </div>
        );
    }

    onFocusOfAddButton() {
        this.setState({
            addButtonIsFocused: true
        });
    }

    onBlurOfAddButton() {
        this.setState({
            addButtonIsFocused: false
        });
    }

    renderActionButton() {
        const alreadyContained = articleUtils.containsBettyBundleId(
            this.props.articleIds.selectedBundleId,
            this.props.listOfArticles
        );
        if (this.props.replace) {
            if (alreadyContained) {
                const message = this.context.intl.formatMessage({
                    id: "EX_ARTICLE_ALREADY_IN_LIST"
                });
                return (
                    <Button block bsStyle="primary" className="addToBasketButton" disabled title={message}>
                        <i className="icon-reorder icon-lg" />
                    </Button>
                );
            } else {
                return (
                    <Button block bsStyle="primary" className="addToBasketButton" onClick={this.handleReplaceArticle}>
                        <i className="icon-reorder icon-lg" />
                    </Button>
                );
            }
        }

        const unitSize = this.getBundleInfo();
        const strokePrice = this.props.priceAndPromotionInfo.strikeThroughNet;
        const variantName = this.props.trackingInfo.variantName;
        const categoryPath = this.props.trackingInfo.categoryPath;
        const brandName = this.props.trackingInfo.brandName;
        const subsysNumber = this.props.trackingInfo.subsysNumber;
        const mgbNumber = this.props.trackingInfo.mgbNumber;
        const trackingData = {
            originEventId: this.eventId,
            inContainer: this.props.inContainer || undefined,
            onList: this.props.onList,
            recentlyOrdered: this.props.recentlyOrdered,
            recentlyOrderedDateString: this.props.recentlyOrderedDateString,
            promotion: this.props.priceAndPromotionInfo.isPromotion,
            pageType: this.props.pageType,
            zeroResultType: this.props.zeroResultType,
            bettyBundleId: this.props.articleIds.selectedBundleId,
            trackingId: this.props.articleIds.trackingId,
            description: this.props.description,
            marketplace: this.props.marketplace,
            offerId: this.props.articleIds.offerId,
            articleFinalNetValue: this.props.priceAndPromotionInfo.unitNet,
            currency: this.props.priceAndPromotionInfo.currency,
            brandName: brandName ? brandName : "no-brand",
            variantName: variantName ? variantName : "no-variant",
            categoryPath: categoryPath ? categoryPath : "no-category",
            strokePrice: strokePrice ? strokePrice : undefined,
            unitSize: unitSize ? unitSize : "no-unit-size",
            subsysNumber: subsysNumber ? subsysNumber : undefined,
            mgbNumber: mgbNumber ? mgbNumber : undefined,
            weight: this.getWeight(),
            listPosition: this.props.listPosition,
            listId: this.props.listInformation?.listId || undefined,
            availability: this.props.availabilityInfo?.availability || undefined,
            loggedIn: SessionStore.loggedIn(),
            url: this.props.pvLink.pathname,
            imageSrc: this.props.imageUrls.bundle || this.props.imageUrls.bundleFallBack,
            ownBrand: this.props.trackingInfo?.ownBrand,
            ropoRank: this.props.trackingInfo?.ropoRank
        };
        const buyability = this.props.buyability;

        const AddButton = this.props.addButton || AddToBasketControl;
        const isDisabled = canNotBeAddedToBasket(
            this.props.deprecated,
            this.props.nonExistentBundle,
            this.props.cartEnabled,
            buyability
        );
        return (
            <AddButton
                idForBasket={this.props.articleIds.idForBasket}
                amountInBasket={this.props.amountInBasket}
                priceInBasket={this.props.priceInBasket}
                onFocus={() => this.onFocusOfAddButton()}
                onBlur={() => this.onBlurOfAddButton()}
                listId={this.props.listInformation.listId || undefined}
                preAmount={this.props.listInformation.listAmount || 0}
                readOnly={this.props.readOnly}
                loggedIn={SessionStore.loggedIn()}
                isTier12Customer={isTier12Customer()}
                isWeightArticle={this.props.isWeightArticle}
                weightPerPiece={this.props.weightPerPiece}
                netPieceWeight={this.props.netPieceWeight}
                dnrInfo={this.props.priceAndPromotionInfo.summaryDnrInfo}
                onlyEmployeeBuyable={!buyability.customer && buyability.employee}
                deliveryMode={buyability.deliveryMode}
                minOrderQuantity={this.props.minOrderQuantity}
                trackingData={trackingData}
                tabIndex={this.props.tabIndex}
                disabled={isDisabled}
                priceAndPromotionInfo={this.props.priceAndPromotionInfo}
            />
        );
    }

    renderArticleIdAndReplacementAndFreeGifts() {
        let className = "";
        if (this.props.deprecated) {
            className = "deprecated";
        } else if (this.props.recentlyOrdered) {
            className = "recently-ordered";
        }
        return (
            <div className="mfcss_card-article-2--articlenumber" role="region" aria-label="Article number">
                <p className={className} style={{ fontSize: "100%", lineHeight: "1.5" }}>
                    {this.renderBundleLabel()}
                    {this.renderMinOrderQuantityLabel()}
                    {this.props.articleIds.idForDisplay}
                    {this.props.renderedDeprecatedArticle ? (
                        <DisplayReplacementPopover renderedDeprecatedArticle={this.props.renderedDeprecatedArticle} />
                    ) : null}
                </p>
            </div>
        );
    }

    renderCorrectAmount(originalAmount: number | undefined | null) {
        return calculateAmountToDisplay(originalAmount, this.props.isWeightArticle, this.props.weightPerPiece);
    }

    renderShopInformation() {
        if (this.props.marketPlaceShopInfo.shopId) {
            const link = "/merchantInformation/" + this.props.marketPlaceShopInfo.shopId;
            return (
                <div className="mfcss_card-article-2--shopname ex-offer-shopname">
                    <FormattedMessage id="EX_ARTICLE_OFFER_SOLD_BY" />{" "}
                    <Link to={link} className="ex-offer-shoplink" onClick={this.handleMerchantLinkClick}>
                        {this.props.marketPlaceShopInfo.shopName}
                    </Link>
                    <OverlayTrigger
                        trigger={["click", "hover", "focus"]}
                        placement="top"
                        overlay={
                            <Popover id="popoverSummary">
                                <FormattedMessage id={"EX_MARKETPLACE_ARTICLE_EXPLANATION_POPOVER"} />
                            </Popover>
                        }>
                        <span className="mfcss_info-icon" />
                    </OverlayTrigger>
                </div>
            );
        }
        return null;
    }

    renderMinOrderQuantityLabel() {
        return this.props.minOrderQuantity ? (
            <span className="label label-frame label-rectangular moq-label">
                <FormattedMessage
                    id={"EX_MIN_ORDER_QUANTITY"}
                    values={{ minOrderQuantity: this.props.minOrderQuantity }}
                />
            </span>
        ) : null;
    }

    renderBundleLabel() {
        const bundleInfo = this.getBundleInfo();
        return bundleInfo ? <span className="label label-frame label-rectangular">{bundleInfo}</span> : null;
    }

    getBundleInfo() {
        const bundleId = this.props.articleIds.selectedBundleId;
        if (!bundleId) {
            return null;
        }
        const bundleName = _.get(this.props.bundleSelector, [bundleId]);
        const weightPerPiece = this.props.weightPerPiece;
        return weightPerPiece
            ? this.context.intl.formatMessage(
                  { id: "EX_WEIGHT_PER_PIECES" },
                  {
                      weightPerPiece: this.context.intl.formatNumber(weightPerPiece.value),
                      unitOfMeasurement: weightPerPiece?.unit?.toLowerCase()
                  }
              )
            : bundleName;
    }

    getWeight() {
        if (this.props.isWeightArticle) {
            return this.props.weightPerPiece ? this.props.weightPerPiece.value : 1;
        }
        return 1;
    }

    renderNonExistent = () => {
        if (!this.props.nonExistentBundle) {
            return null;
        }
        return (
            <p className="small">
                <span className="text-danger">
                    <FormattedMessage id="CA_PERSONALLIST_NON_EXISTENT_BUNDLE" />
                </span>
            </p>
        );
    };

    renderCheckboxField = (
        articleSelectionListProps: ArticleSelectionListProps | undefined | null,
        originalBundleId: string | null | undefined
    ) => {
        if (articleSelectionListProps && articleSelectionListProps.showSelectionCheckbox && originalBundleId) {
            return (
                <div className="mfcss_card-article-2--checkbox">
                    <input
                        className="test-select-checkbox"
                        type="checkbox"
                        checked={articleSelectionListProps && articleSelectionListProps.isSelected}
                        onChange={() => this.handleCheck(originalBundleId)}
                    />
                </div>
            );
        } else return null;
    };

    handleCheck = (id: string) => {
        const articleSelectionListProps = this.props.articleSelectionListProps;
        if (articleSelectionListProps) {
            articleSelectionListProps.selectionAction([id], !articleSelectionListProps.isSelected);
        }
    };

    render() {
        const showDeleteButton = !!this.props.deleteAction && !this.props.readOnly;

        const price = (
            <BundlePrice
                id={this.props.articleIds.selectedBundleId || ""}
                priceAndPromotionInfo={this.props.priceAndPromotionInfo}
                isWeightArticle={this.props.isWeightArticle}
                weightPerPiece={this.props.weightPerPiece}
                secondaryPriceConfig={
                    _.size(this.props.bundleSelector) <= 1 ? "DoNotShowUnitPriceForBundle" : undefined
                }
                amountInBasket={this.props.amountInBasket || 0}
                isEmployee={SessionStore.isEmployee()}
            />
        );
        const maybe = this.props.nonExistentBundle ? null : (
            <React.Fragment>
                {this.renderArticleIdAndReplacementAndFreeGifts()}
                {this.renderAvailability()}
                {this.renderShopInformation()}
                {this.renderSecondaryActions(showDeleteButton)}
            </React.Fragment>
        );

        const articleSelectionListProps = this.props.articleSelectionListProps;
        const isSelected = articleSelectionListProps && articleSelectionListProps.isSelected;
        const isSelectedClass = isSelected ? " mfcss_card-article-2--selected test-selected" : "";
        const errorClass =
            this.props.nonExistentBundle && !isSelected ? "mfcss_card-article-2--has-error test-error" : "";
        const articleBadgeType = ListPageUtils.isAListPage(this.props.pageType) ? "list" : "default";

        const classBase = "mfcss_card-article-2--type-" + articleBadgeType;
        const className =
            "mfcss_card-article-2 " +
            (isTouchScreen() ? "mfcss_card-article-2--is-tablet-display " : "") +
            classBase +
            " " +
            classBase +
            "-v2" +
            " testArticleCard " +
            errorClass +
            isSelectedClass;

        const originalBundleId = this.props.articleIds.forListActions.originalBundleId;
        const isShoppingListView = this.props.pageType === "SHOPPING_LIST";
        const shoppingListWrapperCls = isShoppingListView ? "mfcss_shopping-list-article-wrapper" : "";

        return (
            <div className={"mfcss_article-wrapper " + shoppingListWrapperCls}>
                {isShoppingListView && this.renderCheckboxField(articleSelectionListProps, originalBundleId)}
                <div className={className} role="region" aria-label="Article card">
                    <div className="mfcss_card-article-2--container-flex" role="region" aria-label="Article card">
                        {this.renderArticleImage()}
                        <div className="mfcss_card-article-2--info" role="region" aria-label="Article card">
                            <PromotionLabels
                                priceAndPromotionInfo={this.props.priceAndPromotionInfo}
                                rewardIds={this.rewardIds}
                                onList={this.props.onList && articleBadgeType !== "list" && !this.props.inContainer}
                                recentlyOrdered={
                                    this.props.recentlyOrdered && (this.props.onList || !this.props.inContainer)
                                }
                                recentlyOrderedDateString={this.props.recentlyOrderedDateString}
                                bundleId={this.props.articleIds.selectedBundleId}
                                eventId={this.eventId}
                                trackingId={this.props.articleIds.trackingId}
                                trackingInfo={this.props.trackingInfo}
                            />
                            <TitlePanel
                                detailLink={this.props.pvLink}
                                description={this.props.description}
                                name={this.props.description}
                                articleDeprecated={this.props.deprecated}
                                onClick={_.bind(this.handleLinkClick, this, "title")}
                            />
                            {maybe}
                            {this.renderNonExistent()}
                            {this.getEVAlternativesButtonWithModalIfApplicable()}
                        </div>
                        {this.props.nonExistentBundle ||
                            this.shouldShowAlternativesButtonPlusInNewDesign() ||
                            this.renderPrice(price)}
                        {this.renderActions(showDeleteButton)}
                        {!isShoppingListView && this.renderCheckboxField(articleSelectionListProps, originalBundleId)}
                        {this.props.debugInfo && (
                            <SearchResultDebugInfoPanel
                                debugInfo={this.props.debugInfo}
                                ltrDebugInfo={this.props.ltrDebugInfo}
                                articleVariantId={this.props.articleIds.articleVariantId}
                            />
                        )}
                        {this.renderBundleSelector()}
                    </div>
                </div>
            </div>
        );
    }
}

export default ArticleCard;
